<div class="container pt-5 admin">
    <h2 class="mb-4">Email providers routing override</h2>
    @for (provider of email_providers?.overrides; track provider) {
    <div class="row"
        [ngStyle]="{'background-color': provider.from == provider.to?'none':'#F5838C'}">
        <div class="col-md-2">{{provider.from}}</div>
        <div class="col-md-1"><i class="far fa-arrow-right"></i></div>
        <div class="col-md-2">
            <select class="form-select"
                (change)="updateProvider(email_providers)"
                [(ngModel)]="provider.to">
                @for (option of email_providers?.overrides; track option) {
                <option>{{option.from}}</option>
                }
            </select>
        </div>
    </div>
    }
</div>